import React from "react";
//components & containers
// import Banner from "../presentational_components/navBar";
import AppWrapper from "../presentational_components/wrapper.js";
import VerticalStepper from "./steppers.js";
import {withRouter} from "react-router-dom";
import {Content} from "../styles/App_styles.js";
//== material ui components
import {CssBaseline} from "@material-ui/core";

function App() {
  let props = {name: "Ditto Demo", pub_ancor: "http://www.vldb.org/pvldb/vol14/p50-li.pdf", blog_link: "https://megagon.ai/blog/deep-entity-matching-with-pre-trained-language-models/"}

  return (
    <>
      <CssBaseline />
      <AppWrapper props={props}>
        <Content>
          <VerticalStepper />
        </Content>
      </AppWrapper>
    </>
  );
}

export default withRouter(App);
